import { app } from "./main-app";
import window from "@shared/utils/app-window.ts";

import myjfrogRouter from "../router";
import partnerRouter from "../partner-router";

app.use(
  window.OPERATION_MODE === "partner_portal" ? partnerRouter : myjfrogRouter,
);
